import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_manage/manage/admin/dashboard/cron-jobs')({
  beforeLoad: () => {
    throw redirect({
      to: '/manage/admin/settings',
      search: { tab: 'cron-jobs' },
      replace: true,
    })
  },
})
